import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index.vue'
import Auth from '@/views/Auth.vue'
import NotFound404 from '@/views/common/NotFound404.vue'
import Forbidden from '@/views/common/Forbidden.vue'
import NoSchoolConnectedView from '@/views/common/NoSchoolConnectedView.vue'

import UI_ESH from '@/views/UI_ESH.vue'
import UI_ESH_PARENT from '@/views/UI_ESH_PARENT.vue'
import ParentsRoutes from './parents'
import AdminRoutes from './admin'
import TeacherRoutes from './teacher'
import DepartmentRoutes from './department'
import MunicipalityRoutes from './municipality'
import SuperAdminRoutes from './superadmin'

import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth
  },
  //
  {
    path: '*',
    name: '404',
    component: NotFound404
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: Forbidden
  },
  {
    path: '/no-school-connected',
    name: 'NoSchoolConnectedView',
    component: NoSchoolConnectedView
  },
  //
  {
    path: '/ui-esh',
    name: 'ui',
    component: UI_ESH
  },
  {
    path: '/ui-esh-parent',
    name: 'ui-parent',
    component: UI_ESH_PARENT
  },
  ParentsRoutes,
  AdminRoutes,
  TeacherRoutes,
  DepartmentRoutes,
  MunicipalityRoutes,
  SuperAdminRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV !== 'development') {
    if (to.path === '/') {
      next({ path: '/superadmin/' })
      return
    }
  }
  store.dispatch('INIT').then(({ tokenData }) => {
    const roles = tokenData ? tokenData.roles : []
    const firstMatchedRoute = to.matched[0]

    if (!firstMatchedRoute.meta || !firstMatchedRoute.meta.role || roles.includes(firstMatchedRoute.meta.role)) {
      next()
      return
    }

    if (firstMatchedRoute.meta.auth) {
        next({ name: firstMatchedRoute.meta.auth })
      } else {
        next({ name: 'Forbidden' })
      }
  }).catch(error => {
    Vue.notify({
      type: 'error',
      text: `${error}`
    })
  })
})

export default router
